import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

const StyledAccordion = withStyles({
    root: {
        border: '1px solid rgba(0,0,0,.125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
    },
    expanded: {
        margin: 'auto',
    },
})(Accordion);

const StyledAccordionSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0,0,0,.03)',
        borderBottom: '1px solid rgba(0,0,0,.125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(props => <AccordionSummary {...props} />);

AccordionSummary.muiName = 'AccordionSummary';

const StyledAccordionDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(AccordionDetails);


class FactsForTheVisitor extends Component {

    state = {
        expanded: "General Information",
        sections: [
            {
                title: "General Information",
                renderFunction: this.renderGeneral
            },
            {
                title: "When to Visit",
                renderFunction: this.renderWhenTo
            }
        ]
    };

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    render() {
        const {expanded, sections} = this.state;

        return (
            <div style={{marginTop: '10px'}}>
                <p style={{width: "100%", textAlign: "center"}}>Click to expand</p>
                {
                    sections.map(sec => (
                        <StyledAccordion
                            square
                            expanded={expanded === sec.title}
                            onChange={this.handleChange(sec.title)}
                            key={sec.title}
                        >
                            <StyledAccordionSummary>
                                {sec.title}
                            </StyledAccordionSummary>
                            <StyledAccordionDetails>
                                {sec.renderFunction()}
                            </StyledAccordionDetails>
                        </StyledAccordion>
                    ))
                }
            </div>
        );
    }

    renderGeneral() {
        return (
            <div>
                <b>Riad Remmy Additional Services:</b>
                <ul className="ramadan">
                    <li>All guests are met on arrival and walked to Riad Remmy. We are pleased to offer a map of
                        Essaouira and a tour of the medina. Complimentary drinks are served on arrival.
                    </li>
                    <li>Hairdryer is available upon request.</li>
                    <li>There is a travelcot and highchair available for use.</li>
                    <li>Riad Remmy offers a laundry facility for guests (ask Sandra for prices).</li>
                </ul>

                <p><b>Country Dialing Code:</b> +212</p>

                <p><b>Currency:</b> Moroccan Dirham (closed currency). You can get this at the
                    airport on arrival, cash machines and banks/bureau de change. Euros are also widely used in
                    Essaouira.
                </p>

                <p><b>Electrical:</b> Electrical supply is 127/220V 50Hz. European style with 2
                    circular metal pin plugs are used.</p>

                <p><b>Health &amp; Safety:</b> <br/>
                    Please ensure you have appropriate travel
                    insurance as there is no free health care in Morocco. There are a number of local pharmacies in
                    Essaouria and there is a small hospital. Flooring and stairs are tiled and pavements can be uneven
                    under foot. In the rare instances of heavy rain the streets can become very slippy and saturated so
                    extra care should be taken. </p>
                <p>All bedrooms at Riad Remmy are secured with a padlock and this should be used. We can take no
                    responsibility for injury or theft. Payment of deposit will assume acceptance and agreement to
                    this.</p>
                <p>There is no phone in the riad but mobiles work fine and there are plenty of payphones and internet
                    cafes for Skype and Emailing.</p>
                <p>Essaouira is safe to walk around day and night for adults and children. The medina can get busy in
                    the evenings so extra care should be taken with children. Our family and friends have brought their
                    children here and all have loved Essaouira, our daughter Remmy loves the beach!</p>

                <p><b>Languages Spoken:</b> Arabic &amp; French (English is of course widely
                    spoken in restaurants and shops).</p>

                <p><b>Ramadan:</b> Ramadan is observed and celebrated here. Please check online
                    to find current dates for this.</p>

                <p><b>Time Zone:</b> GMT/UTC 0</p>

                <p><b>Taxis:</b> Taxi cabs do not have meters. You will find small blue cars at
                    the end of the Medina which can transport up to 3 passengers. Tariff – 6DH from 08.00 – 20.00 and
                    7DH from 20.00 – 08.00.</p>

                <p><b>Weights &amp; Measures:</b> Metric.</p>

                <p><b>Water:</b> You should only drink bottled water.</p>

                <b>Useful websites on Essaouira:</b>
                <ul>
                    <li><a href="http://www.essaouira.com/Anglais/album.php">www.essaouira.com</a></li>
                    <li><a href="http://whc.unesco.org/en/list/753/">www.unesco.org</a></li>
                    <li><a href="http://www.festival-gnaoua.net/">www.festival-gnaoua.net</a></li>
                </ul>
            </div>
        );
    }

    renderWhenTo() {
        return (
            <div>
                <h3>When to Visit Morocco?</h3>
                <p>The cooler months in Essaouira are from October to April and are generally popular among visitors.
                    This time of year is pleasantly warm to hot (around 27&deg;C) during the day and cooler (around
                    15&deg;C) at night. May through to September sees temperatures increase to approximately 30-35&deg;C
                    however with the cooling breeze from the ocean the climate in Essaouira is always enjoyable.</p>
                <p><a href="https://www.bbc.co.uk/weather/2549263">www.bbc.co.uk/weather</a></p>
            </div>
        );
    }
}

export default FactsForTheVisitor

